/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

import CustomButton from '~/components/layout/CustomButton';

export const Container = styled.div`
  padding: 70px;
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 37px;
  display: flex;
  align-items: center;
  color: #0b24fb;
`;

export const Text = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 29px;
  color: #7a7a7a;
  max-width: 538px;
`;

export const ContainerInformation = styled.div`  
  border-radius: 4px;
  padding: 13px 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 448px;
  align-items: flex-start;

  @media (max-width: 959px) {
    width: 100%;
    padding: 20px;
  }
`;

export const CheckBoxContainer = styled.div`
  & > svg {
    color: ${({ theme }) => theme.colors.lightGreen}
`;

export const ImgCongratulations = styled.img``;

export const InformationWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 18px;
`;

export const InformationTitle = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: #0000ff;
`;

export const InformationSubTitle = styled.span`
  font-weight: 400;
  font-size: 13px;
  line-height: 25px;
  color: #0000ff;
`;

export const InformationText = styled.span`
  font-weight: 400;
  font-size: 11px;
  line-height: 17px;
  color: #0000ff;
  max-width: 347px;
`;

export const InformationSeparator = styled.div`
  width: 347px;
  height: 0px;
  border: 1px dashed #0000ff;
  margin: 8px 0;
  width: 100%;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px !important;

  button {
    + button {
      margin-top: 16px;
    }
    @media (max-width: 959px) {
      width: 100%;
    }
  }
`;

export const ButtonNext = styled(CustomButton)``;

export const UllyWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 448px;

  @media (max-width: 959px) {
    max-width: 100%;
  }
`;

export const UllyInformation = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  text-align: center;  
  color: #0b29fb;
  margin-top: 18px;
  display: inline-block;
  width: 258px;
`;
